import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';

const QRScanner = () => {
  const [contactInfo] = useState({
    name: 'Sunil Nair',
    phone: '+91 9930351241',
    email: 'newideainvestment05@gmail.com',
    address: 'Panvel, Navi Mumbai'
  });

  // Human-readable QR value
  const qrValue = `BEGIN:VCARD
VERSION:3.0
N:Sunil Nair
TEL:+91 9930351241
EMAIL:newideainvestment05@gmail.com
ADR:Panvel, Navi Mumbai
END:VCARD`;

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 via-white to-blue-200 py-16 flex items-center">
      <div className="max-w-md mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="text-center mb-10">
          <h2 className="text-4xl font-extrabold text-gray-900 sm:text-5xl">
            Scan QR Code
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Scan this QR code to get our contact information instantly.
          </p>
        </div>

        <div className="flex justify-center">
          <div className="bg-white p-8 rounded-2xl shadow-2xl border border-blue-100 transition-transform duration-300 hover:scale-105">
            <QRCodeSVG
              value={qrValue}
              size={256}
              level="H"
              includeMargin={true}
              className="mx-auto"
            />
            <div className="mt-6 text-center">
              <h3 className="text-xl font-semibold text-blue-700 mb-2">
                Contact Information
              </h3>
              <div className="mt-2 space-y-1 text-gray-700">
                <p><span className="font-medium">Name:</span> {contactInfo.name}</p>
                <p><span className="font-medium">Phone:</span> {contactInfo.phone}</p>
                <p><span className="font-medium">Email:</span> {contactInfo.email}</p>
                <p><span className="font-medium">Address:</span> {contactInfo.address}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QRScanner; 